 export enum DsnTypeDeclaration {
Normale = 0,
NormaleNeant = 1,
AnnuleEtRemplaceIntegral = 2,
Annule = 3,
AnnuleEtRemplaceNeant = 4,
}


// WEBPACK FOOTER //
// ./src/dto/GenApi.iNotPaie.Dto/DsnTypeDeclaration.ts